import type Player from 'video.js/dist/types/player';

const FAIRPLAY_KEY_SYSTEM = 'com.apple.fps.1_0';

type LicenseHeaders = Record<string, string>;

function getFairplayLicenseHeaders(drm: any): LicenseHeaders | undefined {
  const headers = drm?.fairplay?.license_headers;

  if (!headers || typeof headers !== 'object') return undefined;

  return headers as LicenseHeaders;
}

/**
 * FairPlay Specifics for Axinom
 * https://docs.axinom.com/services/drm/players/videojs#fairplay-specifics */
export default function axinomFairplayConfig(player: Player, drm: any) {
  player.eme();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (player.eme as any)?.initLegacyFairplay?.();

  const licenseUrl: string | undefined = drm?.fairplay?.license_server_url;

  const certificateUrl: string | undefined = drm?.fairplay?.certificate_url;

  const headers = getFairplayLicenseHeaders(drm);

  return {
    type: 'application/x-mpegURL',
    keySystems: {
      [FAIRPLAY_KEY_SYSTEM]: {
        licenseUri: licenseUrl,
        certificateUri: certificateUrl,
        getContentId: function (_: any, initData: any) {
          return new TextDecoder().decode(
            initData.filter((item: any) => item !== 0 && item !== 150)
          );
        },
        licenseHeaders: headers,
      },
    },
  };
}
